import { render, staticRenderFns } from "./ride-month-template.vue?vue&type=template&id=58612f6e&scoped=true&lang=pug&"
import script from "./ride-month-template.vue?vue&type=script&lang=js&"
export * from "./ride-month-template.vue?vue&type=script&lang=js&"
import style0 from "./ride-month-template.vue?vue&type=style&index=0&id=58612f6e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58612f6e",
  null
  
)

export default component.exports